var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mainmenu-logout",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.016,
    height: 20.661,
    viewBox: "0 0 20.016 20.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4342",
    "data-name": "Group 4342",
    transform: "translate(0.016 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4341",
    "data-name": "Group 4341",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    d: "M231.859,354.159a.932.932,0,0,0-1.312,0,.918.918,0,0,0,0,1.3l2.745,2.727H221.928a.922.922,0,1,0,0,1.843h11.364l-2.745,2.727a.917.917,0,0,0,0,1.3.932.932,0,0,0,1.312,0l4.328-4.3a.917.917,0,0,0,0-1.3Zm0,0",
    transform: "translate(-217.313 -348.436)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    "data-name": "Path 4144",
    d: "M181.588,310.174a.923.923,0,0,0,0-1.844h-6.812v-16.6h6.812a.923.923,0,0,0,0-1.844h-7.7a.906.906,0,0,0-.888.922v18.44a.905.905,0,0,0,.888.922Zm0,0",
    transform: "translate(-173 -289.513)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuLogout);
export default __webpack_public_path__ + "static/media/Mainmenu-logout.2e0d1d1e2f2cd098ca58fc692ffe1bac.svg";
export { ForwardRef as ReactComponent };